
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agb",
      function () {
        return require("private-next-pages/agb.tsx");
      }
    ]);
  